
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
.loading-bar-wrapper {
  width: 100%;
  height: 4px;
  background-color: var(--slh-color-neutral-shade-20, #EBEEF4);
  border-radius: 24px;
  outline: none;
}
.loading-bar-wrapper .progress {
  width: var(--loading-bar-progress);
  height: 4px;
  display: block;
  border-radius: 24px;
  transition: width 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}
.loading-bar-wrapper.indeterminate .progress {
  width: 100%;
  animation: indeterminateAnimation 1s infinite linear;
  transform-origin: left center;
}
.loading-bar-wrapper .slh-primary-loading-bar {
  background-color: #4B61C8;
}
.loading-bar-wrapper .slh-error-loading-bar {
  background-color: #DD5350;
}
.loading-bar-wrapper .slh-info-loading-bar {
  background-color: #3B87D4;
}
.loading-bar-wrapper .slh-warning-loading-bar {
  background-color: #F5A83D;
}
.loading-bar-wrapper .slh-success-loading-bar {
  background-color: #60B34A;
}

@keyframes indeterminateAnimation {
  0% {
    transform: scaleX(0);
  }
  40% {
    transform: scaleX(0.4);
  }
  100% {
    transform: scaleX(1);
  }
}
.slh-loading-bar {
  width: 100%;
}

:host .primary .progress {
  background: var(--slh-color-primary, #3B87D4);
}
:host .success .progress {
  background: var(--slh-color-success, #00B894);
}
:host .info .progress {
  background: var(--slh-color-info, #74B9FF);
}
:host .warning .progress {
  background: var(--slh-color-warning, #FDCB6E);
}
:host .error .progress {
  background: var(--slh-color-error, #FF7E70);
}
`;
